import { z } from 'zod'
import dayjs from 'dayjs'

/**
 * 게시판 스키마 정의
 * - 폼 검증 규칙 및 기본값 설정
 * - TypeScript 타입 추론을 위한 Zod 스키마
 */
export const boardSchema = z.object({
	id: z.number().optional().default(0),
	code: z.string().min(1, '분류를 선택해주세요').optional().default('1000'),
	type: z.string().min(1, '공지 유형을 선택해주세요').optional().default(''),
	title: z
		.string()
		.min(3, '제목을 입력해주세요')
		.max(200, '제목은 200자 이하로 입력해주세요'),
	content: z.string().min(3, '내용을 입력해주세요'),
	startDate: z
		.string()
		.optional()
		.default(() => dayjs().format('YYYY-MM-DD HH:mm:ss')),
	endDate: z
		.string()
		.optional()
		.default(() => dayjs().format('YYYY-MM-DD HH:mm:ss')),
	regId: z.string().optional(),
	fileDetailIds: z.array(z.number()).optional().default([]),
})

/**
 * 게시판 폼 데이터 타입
 * Zod 스키마로부터 TypeScript 타입 자동 추론
 */
export type BoardFormData = z.infer<typeof boardSchema>

/**
 * 게시판 기본값 객체
 * 폼 초기화 시 사용
 */
export const boardDefaultValues: BoardFormData = {
	id: 0,
	code: '1000',
	type: '',
	title: '',
	content: '',
	startDate: dayjs().format('YYYY-MM-DD HH:mm:ss'),
	endDate: dayjs().format('YYYY-MM-DD HH:mm:ss'),
	regId: undefined,
	fileDetailIds: [],
}
